<script>
import ErrorAlert from "@/components/errorAlert";
import Layout from "../../layouts/main";
import axios from "axios";
import Multiselect from "vue-multiselect";
import { toast, variants } from "@/helpers/toaster";

/**
 * Form Layouts component
 */
export default {
  page: {
    title: "Izmena grupe",
  },
  data() {
    return {
      name: '',
      budget: '',
      selectedAdministrator: null,
      administrators: [],
      administratorQuery: '',
      types: [],
      selectedTypes: [],
      group: null,
      disabled: false,
    };
  },
  components: {ErrorAlert, Layout, Multiselect},
  async created() {
    this.$store.commit('loader/START_LOADING');

    try {
      const typeData = await axios.get('/super-admin/types') 
      this.types = typeData.data;

      await axios.get(`/admin/groups/singleGroup/${this.$route.params.id}`)
        .then(response => {
          const group = response.data;
          this.group = group;

          this.name = group.name;
          this.selectedTypes = group.types;
          this.administratorQuery = group.admin.company_name;
          this.budget = group.budget;
        }).catch((error) => {
          if (error.response && error.response.status === 404) {
            this.$store.commit('errorBag/RECORD', { status:["Grupa nije pronadjena."]});
            this.disabled = true
          }});
    } catch (e) {
      // eslint-disable-next-line no-empty
    } finally {
      this.$store.commit('loader/END_LOADING');
    }
  },
  watch: {
  },
  computed: {
    computedTypes() {
      if (!this.types) return [];
      
      return [
        {
          all: "Izaberi sve vrste",
          types: this.types,
        }
      ]
    }
  },
  methods: {
    async submitForm() {
      this.$store.commit('loader/START_LOADING');

      try {
        const req = {
          name: this.name,
          admin_id: this.administratorQuery,
          types: this.selectedTypes.map(t => t.id),
          budget: this.budget,
        }

        await axios.put(`/admin/groups/${this.$route.params.id}`, req);
        toast('Uspešna izmena grupe.', variants.SUCCESS)
        this.cancel();
      } catch (e) {
        // eslint-disable-next-line no-empty
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    cancel() {
      this.$router.push(`/admin/groups`)
    },
  },
};
</script>

<template>
  <Layout>
    <div>
      <ErrorAlert></ErrorAlert>

      <b-form @submit.prevent="submitForm()">
        
        <div class="row">
          <div class="offset-3 col-md-6">
            <div class="form-group">
              <label>
                Naziv
              </label>
              <b-form-input :disabled="true" v-model="name"  id="group-name-input" type="text"></b-form-input>
            </div>

            <div class="form-group">
              <label class="col-form-label mr-2" for="group-administrator-input">Vrste</label>
              <multiselect
                :disabled="true"
                id="group-types-input"
                v-model="selectedTypes"
                track-by="id"
                label="name"
                :close-on-select="false" 
                :clear-on-select="false"
                :options="computedTypes"
                :group-select="true" 
                group-values="types" 
                group-label="all"
                open-direction="bottom"
                placeholder="Izaberi vrste"
                :multiple="true">
              </multiselect>
            </div>

            <div class="form-group">
              <label>
                Budžet
              </label>
              <b-form-input :disabled="disabled" v-model="budget" placeholder="" 
                            id="group-administrator-input" type="number"></b-form-input>
            </div>

            <div class="text-right">        
              <b-button type="submit" variant="primary" class="ml-2" >Snimi</b-button>
            </div>
          </div>
        </div>
      </b-form>
    </div>
  </Layout>
</template>
<style scoped>

input[type='radio'] {
  display: none;
}

.button {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
  margin: 10px;
  cursor: pointer;
}

.button span {
  position: absolute;
  width: 50px;
  height: 50px;
  padding: 0;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  border-radius: 100%;
  background: #eeeeee;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  transition: ease .3s;

  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;

  color: white;
  font-size: 24px
}

.button span:hover {
  padding: 10px;
}

.orange .button span {
  background: #FF5722;
}

.pink .button span {
  background: #e067ea;
}

.yellow .button span {
  background: #faf15d;
}

.amber .button span {
  background: #FFC107;
}

.lime .button span {
  background: #8BC34A;
}

.teal .button span {
  background: #009688;
}

.blue .button span {
  background: #2196F3;
}

.indigo .button span {
  background: #3F51B5;
}

.autocomplete {
  width: 100%
}

</style>
